import React from "react";
import { Datagrid, List, TextField } from "react-admin";
import { CustomDateField } from "../../../../Components/CustomDateField";

const AltPnList = props => {
  return (
    <List
      {...props}
      resource="alternatepns"
      basePath="alternatepns"
      filter={{ pn__eq: props.pn }}
      perPage={10}
      bulkActionButtons={false}
      exporter={false}
    >
      <Datagrid>
        <TextField source="pnIntchg" label={"Pn"} />
        <TextField source="sn" />
        <TextField source="shelf1" />
        <TextField source="shelf2" />
        <TextField source="tbo" />
        <TextField source="tbr" />
        <CustomDateField source="birthDate" />
        <TextField source="componentAge" />
        <TextField source="condition" />
        <TextField source="location" />
        <TextField source="qtyInTransfer" />
        <TextField source="toLocation" />
      </Datagrid>
    </List>
  );
};

export default AltPnList;
